import React, {useEffect, useState} from "react";
import {formatTime} from "../model/enums";
type DigitalGaugeProps = {
    startTime: Date;
    duration: number; // seconds
};

const DigitalGauge: React.FC<DigitalGaugeProps> = ({startTime, duration}) => {
    const startTimeMs = startTime.getTime();
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        // Yeni bir ON komutu gelirse sayaç o an yeniden başlar.
        setNow(Date.now());

        const interval = setInterval(() => {
            setNow(Date.now());
        }, 1000);

        return () => clearInterval(interval);
    }, [startTimeMs]);

    const elapsedTime = Math.max(
        Math.floor((now - startTimeMs) / 1000),
        0
    );

    const remainingTime = Math.max(duration - elapsedTime, 0);

    return (
        <div className="flex flex-col items-center p-4 bg-gray-900 text-white rounded-lg">
            <div className="text-xs font-mono">
                Geçen Süre: {formatTime(elapsedTime)}
            </div>
            <div className="text-xs font-mono">
                Kalan Süre: {formatTime(remainingTime)}
            </div>
        </div>
    );
};

export default DigitalGauge;
